"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function UpTriangle(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 12 12" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", fillRule: "evenodd", points: "6 3 10 9 2 9", transform: "matrix(-1 0 0 1 12 0)" })));
}
exports.default = UpTriangle;
//# sourceMappingURL=UpTriangle.js.map